import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EnumCodigosTwTcAcciones } from '../../_importacion/solicitudes/types/enum';
import { AccionesPerfilTipoEstadoEditComponent } from './accionesperfiltipoestado/accionesperfiltipoestado-edit.component';
import { AccionesPerfilTipoEstadoListComponent } from './accionesperfiltipoestado/accionesperfiltipoestado-list.component';
import { AccionesPerfilTipoEstadoExEditComponent } from './accionesperfiltipoestadoEx/accionesperfiltipoestadoEx-edit.component';
import { AccionesPerfilTipoEstadoExListComponent } from './accionesperfiltipoestadoEx/accionesperfiltipoestadoEx-list.component';
import { PermisosAccionesAtestFitoWrapperEditComponent } from './permisosaccionesatestfito/permisosaccionesatestfito-wrapper-edit/permisosaccionesatestfito-wrapper-edit.component';
import { PermisosAccionesAtestFitoWrapperComponent } from './permisosaccionesatestfito/permisosaccionesatestfito-wrapper/permisosaccionesatestfito-wrapper.component';
import { PermisosAccionesCamWrapperEditComponent } from './permisosaccionescam/permisosaccionescam-wrapper-edit/permisosaccionescam-wrapper-edit.component';
import { PermisosAccionesCamWrapperComponent } from './permisosaccionescam/permisosaccionescam-wrapper/permisosaccionescam-wrapper.component';
import { PermisosAccionesPvWrapperEditComponent } from './permisosaccionespv/permisosaccionespv-wrapper-edit/permisosaccionespv-wrapper-edit.component';
import { PermisosAccionesPvWrapperComponent } from './permisosaccionespv/permisosaccionespv-wrapper/permisosaccionespv-wrapper.component';
import { PermisosAccionesCpeWrapperEditComponent } from './permisosaccionescpe/permisosaccionescpe-wrapper-edit/permisosaccionescpe-wrapper-edit.component';
import { PermisosAccionesCpeWrapperComponent } from './permisosaccionescpe/permisosaccionescpe-wrapper/permisosaccionescpe-wrapper.component';
import { PermisosAccionesUnidadInspeccionCamWrapperComponent } from './permisosaccionesudinspeccioncam/permisosaccionesudinspeccioncam-wrapper/permisosaccionesudinspeccioncam-wrapper.component';
import { PermisosAccionesUnidadInspeccionCamWrapperEditComponent } from './permisosaccionesudinspeccioncam/permisosaccionesudinspeccioncam-wrapper-edit/permisosaccionesudinspeccioncam-wrapper-edit.component';
import { PermisosAccionesImpresosIyIIIWrapperEditComponent } from './permisosaccionesimpresosIyIII/permisosaccionesimpresosIyIII-wrapper-edit/permisosaccionesimpresosIyIII-wrapper-edit.component';
import { PermisosAccionesImpresosIyIIIWrapperComponent } from './permisosaccionesimpresosIyIII/permisosaccionesimpresosIyIII-wrapper/permisosaccionesimpresosIyIII-wrapper.component';
import { LoginGuard, ActionGuard } from '../../core/_infrastructure/classes/guards/main.guard';

const permisosRoutes: Routes = [
    // ACCIONES PERFIL TIPO ESTADO
    {
        path: 'mantenimiento/permisos/accionesperfiltipoestado',
        data: {
            breadcrumb: 'Permisos Acciones',
            menu0: 'MANTENIMIENTO',
            menu1: 'Permisos',
        },
        children: [
            {
                path: '',
                component: AccionesPerfilTipoEstadoListComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MENU_PERMISOS_ACCIONES,
                },
            },
            /*
            // @author: scalero1
            // @comment: Lo dejamos comentado para posible uso futuro
            {
                path: 'edit/:id',
                component: AccionesPerfilTipoEstadoEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Editar Permiso Acción',
                    actionCode: EnumCodigosTwTcAcciones.MENU_PERMISOS_ACCIONES,
                },
            },
            */
            {
                path: 'create',
                component: AccionesPerfilTipoEstadoEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Nuevo Permiso Acción',
                    actionCode: EnumCodigosTwTcAcciones.MENU_PERMISOS_ACCIONES,
                },
            },
        ],
    },

    // PERMISOS ACCIONES CPE
    {
        path: 'mantenimiento/permisos/permisosaccionescpe',
        data: {
            breadcrumb: 'Permisos Acciones CPE',
            menu0: 'MANTENIMIENTO',
            menu1: 'Permisos',
        },
        children: [
            {
                path: '',
                component: PermisosAccionesCpeWrapperComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MENU_PERMISOS_ACCIONES,
                },
            },

            {
                path: 'create',
                component: PermisosAccionesCpeWrapperEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Nuevo Permiso Acción CPE',
                    actionCode: EnumCodigosTwTcAcciones.MENU_PERMISOS_ACCIONES,
                },
            },
        ],
    },

    // PERMISOS ACCIONES ATESTACIONES FITOSANITARIAS
    {
        path: 'mantenimiento/permisos/permisosaccionesatestfito',
        data: {
            breadcrumb: 'Permisos Acciones Atestaciones Fitosanitarias',
            menu0: 'MANTENIMIENTO',
            menu1: 'Permisos',
        },
        children: [
            {
                path: '',
                component: PermisosAccionesAtestFitoWrapperComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MENU_PERMISOS_ACCIONES,
                },
            },

            {
                path: 'create',
                component: PermisosAccionesAtestFitoWrapperEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Nuevo Permiso Acción Atestación Fitosanitaria',
                    actionCode: EnumCodigosTwTcAcciones.MENU_PERMISOS_ACCIONES,
                },
            },
        ],
    },

    // PERMISOS ACCIONES CAMPAÑAS
    {
        path: 'mantenimiento/permisos/permisosaccionescam',
        data: {
            breadcrumb: 'Permisos Acciones Campañas',
            menu0: 'MANTENIMIENTO',
            menu1: 'Permisos',
        },
        children: [
            {
                path: '',
                component: PermisosAccionesCamWrapperComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MENU_PERMISOS_ACCIONES,
                },
            },

            {
                path: 'create',
                component: PermisosAccionesCamWrapperEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Nuevo Permiso Acción Campaña',
                    actionCode: EnumCodigosTwTcAcciones.MENU_PERMISOS_ACCIONES,
                },
            },
        ],
    },

    // PERMISOS ACCIONES UNIDADES DE INPSECCIÓN DE CAMPAÑAS
    {
        path: 'mantenimiento/permisos/permisosaccionesudsinpeccioncam',
        data: {
            breadcrumb: 'Permisos Acciones Uds. Inspección Campaña',
            menu0: 'MANTENIMIENTO',
            menu1: 'Permisos',
        },
        children: [
            {
                path: '',
                component: PermisosAccionesUnidadInspeccionCamWrapperComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MENU_PERMISOS_ACCIONES,
                },
            },

            {
                path: 'create',
                component: PermisosAccionesUnidadInspeccionCamWrapperEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Nuevo Permiso Acción Ud. Inspección Campaña',
                    actionCode: EnumCodigosTwTcAcciones.MENU_PERMISOS_ACCIONES,
                },
            },
        ],
    },

    // PERMISOS ACCIONES CAMPAÑAS
    {
        path: 'mantenimiento/permisos/permisosaccionespv',
        data: {
            breadcrumb: 'Permisos Acciones P.V.',
            menu0: 'MANTENIMIENTO',
            menu1: 'Permisos',
        },
        children: [
            {
                path: '',
                component: PermisosAccionesPvWrapperComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MENU_PERMISOS_ACCIONES,
                },
            },

            {
                path: 'create',
                component: PermisosAccionesPvWrapperEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Nuevo Permiso Acción P.V.',
                    actionCode: EnumCodigosTwTcAcciones.MENU_PERMISOS_ACCIONES,
                },
            },
        ],
    },

    // ACCIONES PERFIL TIPO ESTADO EXPORTACIÓN
    {
        path: 'mantenimiento/permisos/accionesperfiltipoestadoEx',
        data: {
            breadcrumb: 'Permisos Exportación',
            menu0: 'MANTENIMIENTO',
            menu1: 'Permisos',
        },
        children: [
            {
                path: '',
                component: AccionesPerfilTipoEstadoExListComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MENU_PERMISOS_ACCIONES,
                },
            },
            /*
            // @author: scalero1
            // @comment: Lo dejamos comentado para posible uso futuro
            {
                path: 'edit/:id',
                component: AccionesPerfilTipoEstadoExEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Editar Permiso Acción',
                    actionCode: EnumCodigosTwTcAcciones.MENU_PERMISOS_ACCIONES,
                },
            },
            */
            {
                path: 'create',
                component: AccionesPerfilTipoEstadoExEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Nuevo Permiso Acción',
                    actionCode: EnumCodigosTwTcAcciones.MENU_PERMISOS_ACCIONES,
                },
            },
        ],
    },

    // PERMISOS ACCIONES IMPRESOS I Y III
    {
        path: 'mantenimiento/permisos/permisosaccionesimpresosiyiii',
        data: {
            breadcrumb: 'Permisos Acciones Imp. I y III',
            menu0: 'MANTENIMIENTO',
            menu1: 'Permisos',
        },
        children: [
            {
                path: '',
                component: PermisosAccionesImpresosIyIIIWrapperComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MENU_PERMISOS_ACCIONES,
                },
            },

            {
                path: 'create',
                component: PermisosAccionesImpresosIyIIIWrapperEditComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Nuevo Permiso Acción Impresos I y III',
                    actionCode: EnumCodigosTwTcAcciones.MENU_PERMISOS_ACCIONES,
                },
            },
        ],
    },
];
@NgModule({
    imports: [RouterModule.forChild(permisosRoutes)],
    exports: [RouterModule],
})
export class PermisosRoutingModule {}
